export const columnasAutorizacion = [
    {
        key: "comprobante",
        label: "Comprobante",
        sorted: true,
        fixed: false,
        type: "string",
        hidden: false,
    },
    {
        key: "caeCai",
        label: "CAE/CAI",
        sorted: true,
        fixed: false,
        type: "string",
        hidden: false,
    },
    {
        key: "numeroFactura",
        label: "Número de factura",
        sorted: true,
        fixed: false,
        type: "string",
        hidden: false,
    },
    {
        key: "razonSocial",
        label: "Razón social",
        sorted: true,
        fixed: false,
        type: "string",
        hidden: false,
    },
    {
        key: "cuit",
        label: "CUIT",
        sorted: true,
        fixed: false,
        type: "string",
        hidden: false,
    },
    {
        key: "concepto",
        label: "Concepto",
        sorted: true,
        fixed: false,
        type: "string",
        hidden: false,
    },
    {
        key: "fecha",
        label: "Fecha",
        sorted: true,
        fixed: false,
        type: "date",
        hidden: false,
    },
    {
        key: "importeFormateado",
        label: "Importe",
        sorted: true,
        fixed: false,
        type: "number",
        hidden: false,
        sortKey: "currency"
    },
    {
        key: "primerAutorizante",
        label: "Autorizante N°1",
        sorted: true,
        fixed: false,
        type: "string",
        hidden: false
    },
    {
        key: "motivoGasto",
        label: "Motivo del gasto",
        sorted: true,
        fixed: false,
        type: "string",
        hidden: false,
        cellClassName: 'whitespace-normal break-words overflow-visible'
    },
    {
        key: "acciones",
        label: "",
        sorted: false,
        fixed: false,
        type: "component",
        hidden: false,
    }
]